import Route from '@/routes'

export enum VariableType {
  single = 'single',
  double = 'double',
  triple = 'triple'
}

export interface Variable {
  name: string
  type: VariableType
  description: string

  variable: string
  variable2?: string
  variable3?: string

  placeholder: string
  placeholder2?: string
  placeholder3?: string

  label?: string
  label2?: string
  label3?: string

  frequency: string
}

export interface StepDefinition {
  index: number
  name: string
  title: string
  description: string
  variables: Variable[]
  outro: string
  link: Route
}

const currencySymbol = '€'

export enum Frequency {
  weekly = 'Weekly',
  monthly = 'Monthly',
  annual = 'Annual'
}

export enum FinanceArea {
  Debt = 'Debt Management',
  Budgeting = 'Budgeting',
  Savings = 'Savings',
  Protection = 'Protecting my Family',
  Retirement = 'Retirement Planning',
  Investing = 'Investing',
  Planning = 'Planning for Families',
}

export interface APIData {
  [key: string]: string

  stepReached: string

  email: string
  settingCompare: string
  settingSave: string
  settingConsent: string
  settingFinanceAreas: string

  // step 1
  Net_Income_1_Amt: string
  Net_Income_1_Frequency: string

  Net_Income_2_Amt: string
  Net_Income_2_Frequency: string

  Child_Benefit_Amt: string
  Child_Benefit_Frequency: string

  Inc_Other_1_Amt: string
  Inc_Other_1_Frequency: string

  Inc_Other_2_Amt: string
  Inc_Other_2_Frequency: string


  // step 2
  Rent_Mortgage_Amt: string
  Rent_Mortgage_Freq: string

  Utilities_Amt: string
  Utilities_Freq: string

  TV_Broadband_Amt: string
  TV_Broadband_Freq: string

  TV_Licence_Amt: string
  TV_Licence_Freq: string

  Family_Pet_Amt: string
  Family_Pet_Freq: string

  House_Purchases_Amt: string
  House_Purchases_Freq: string


  // step 3
  Childcare_Amt: string
  Childcare_Freq: string

  Groceries_Amt: string
  Groceries_Freq: string

  Entertainment_Amt: string
  Entertainment_Freq: string

  Petrol_Diesel_Amt: string
  Petrol_Diesel_Freq: string

  Public_Transport_Amt: string
  Public_Transport_Freq: string


  // step 4
  Mobile_Phone_Amt: string
  Mobile_Phone_Freq: string

  Personal_Care_Amt: string
  Personal_Care_Freq: string

  Club_membership_Amt: string
  Club_membership_Freq: string

  Clothing_Amt: string
  Clothing_Freq: string

  Gifts_Amt: string
  Gifts_Freq: string

  Online_Amt: string
  Online_Freq: string


  // step 5
  Credit_Card_1_Bal: string
  Credit_Card_1_Amt: string
  Credit_Card_1_Freq: string

  Credit_Card_2_Bal: string
  Credit_Card_2_Amt: string
  Credit_Card_2_Freq: string

  Personal_Loan_1_Bal: string
  Personal_Loan_1_Amt: string
  Personal_Loan_1_Freq: string

  Personal_Loan_2_Bal: string
  Personal_Loan_2_Amt: string
  Personal_Loan_2_Freq: string

  Car_Loan_1_Bal: string
  Car_Loan_1_Amt: string
  Car_Loan_1_Freq: string

  Car_Loan_2_Bal: string
  Car_Loan_2_Amt: string
  Car_Loan_2_Freq: string

  Debt_Other_Bal: string
  Debt_Other_Amt: string
  Debts_Other_Freq: string


  // step 6
  Home_Insurance_Amt: string
  Home_Insurance_Freq: string

  Car_Insurance_Amt: string
  Car_Insurance_Freq: string

  Health_Insurance_Amt: string
  Health_Insurance_Freq: string

  Mortgage_Protection_Amt: string
  Mortgage_Protection_Freq: string

  Life_Insurance_Amt: string
  Life_Insurance_Freq: string

  Other_Insurances_Amt: string
  Other_Insurances_Freq: string


  // step 7
  Emergency_Fund: string
  Emergency_Fund_Bal: string
  Emergency_Fund_Amt: string
  Emergency_Fund_Freq: string

  Education_Fund: string
  Education_Fund_Bal: string
  Education_Fund_Amt: string
  Education_Fund_Freq: string

  Annual_Holiday: string
  Annual_Holiday_Bal: string
  Annual_Holiday_Amt: string
  Annual_Holiday_Freq: string

  Christmas_Fund: string
  Christmas_Fund_Bal: string
  Christmas_Fund_Amt: string
  Christmas_Fund_Freq: string

  Save_Other_1_Goal: string
  Save_Other_1_Bal: string
  Save_Other_1_Amt: string
  Save_Other_1_Freq: string

  Save_Other_2_Goal: string
  Save_Other_2_Bal: string
  Save_Other_2_Amt: string
  Save_Other_2_Freq: string
}

export { currencySymbol, }
